import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { pickVariantUpdateable } from "functions/tlf/pickVariantUpdateable";
import { cloneDeep, omit } from "lodash";
import { checkChanged } from "./checkChanged";
import { TlfContextProps } from "./interface";
import { updateVariantPatchSelection } from "./updateVariantPatchSelection";

/**
 * Closes patch creation and restores the master when no patch is active.
 *
 * @param state - Current TLF context state
 * @returns Updated TLF context state
 */
export const tlf_cancelVariantPatchCreation = (state: TlfContextProps): TlfContextProps => {
  let newState: TlfContextProps = { ...state, showCreateVariantPatchWindow: false };
  if (state.activeVariantPatchName !== null) return newState;

  const current = isArsMasterReadDto(state.tlfData) ? state.tlfData : null;
  const master = state.masterTlfData;
  if (master === null) return newState;

  const restored = {
    ...(current ?? master),
    ...pickVariantUpdateable(master),
    allVariantPatches: current?.allVariantPatches ?? {},
    variantTemplates: current?.variantTemplates ?? [],
  };
  const isEmptyMaster =
    Object.keys(restored.allVariantPatches).length === 0 && restored.variantTemplates.length === 0;
  const tlfData = isEmptyMaster
    ? omit(restored, ["allVariantPatches", "variantTemplates"])
    : restored;
  const ixTlfDataVersion = state.ixTlfDataVersion + 1;
  newState = {
    ...newState,
    tlfData,
    ixTlfDataVersion,
    ixSaveVersion: state.ixSaveVersion > state.ixTlfDataVersion ? -1 : state.ixSaveVersion,
    tlfDataVersions: [...state.tlfDataVersions.slice(0, ixTlfDataVersion), cloneDeep(tlfData)],
    masterTlfData: isEmptyMaster ? null : cloneDeep(master),
    appliedVariantPatches: [],
    activeVariantPatchName: null,
    variantCreationView: false,
    forcePushToParent: true,
  };
  const selectedState = updateVariantPatchSelection(newState, [], null);
  checkChanged(selectedState);
  return selectedState;
};
